var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctCustomArray, FctTupleArray } from '../../../Fct/generics';
import { getSupportedTokens } from '../allowanceRequiredProtocols';
export var GetPool = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getPool',
    name: 'getPool',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                poolAddress: new FctAddress({ required: false }),
                token1: new FctAddress({ options: getSupportedTokens({ chainId: chainId }), required: false }),
                token2: new FctAddress({ options: getSupportedTokens({ chainId: chainId }), required: false }),
                'pool_tuple[]': new FctTupleArray({
                    params: {
                        poolAddress: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }) }),
                        poolName: new FctCustomArray({ required: false }),
                        token1: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }), required: false }),
                        token2: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }), required: false }),
                    },
                    hidden: true,
                }),
                methodParams: {},
            },
            output: {},
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var chainId = _a.chainId, input = _a.input;
        var pool_tuple = input['pool_tuple[]'];
        var getPoolAddressList = function (_a) {
            var changedParamKey = _a.changedParamKey;
            return __awaiter(void 0, void 0, void 0, function () {
                var poolAddresses, poolNames_1, tokens1_1, tokens2_1, poolOptions_1, poolAddress_1;
                var _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    if (!changedParamKey) {
                        return [2 /*return*/, {
                                params: {},
                                error: undefined,
                            }];
                    }
                    switch (changedParamKey) {
                        case 'pool_tuple[]':
                            poolAddresses = (_b = pool_tuple.params.poolAddress) === null || _b === void 0 ? void 0 : _b.value;
                            poolNames_1 = (_c = pool_tuple.params.poolName) === null || _c === void 0 ? void 0 : _c.value;
                            tokens1_1 = (_d = pool_tuple.params.token1) === null || _d === void 0 ? void 0 : _d.value;
                            tokens2_1 = (_e = pool_tuple.params.token2) === null || _e === void 0 ? void 0 : _e.value;
                            if (!poolAddresses || !('length' in poolAddresses) || !(poolAddresses === null || poolAddresses === void 0 ? void 0 : poolAddresses.length)) {
                                return [2 /*return*/, {
                                        params: {},
                                        error: undefined,
                                    }];
                            }
                            poolOptions_1 = [];
                            poolAddresses.forEach(function (poolAddress, index) {
                                var coins = [];
                                if ((tokens1_1 === null || tokens1_1 === void 0 ? void 0 : tokens1_1[index]) && (tokens2_1 === null || tokens2_1 === void 0 ? void 0 : tokens2_1[index])) {
                                    coins = [
                                        {
                                            address: tokens1_1[index],
                                        },
                                        {
                                            address: tokens2_1[index],
                                        },
                                    ];
                                }
                                var option = {
                                    value: poolAddress,
                                    name: poolNames_1 === null || poolNames_1 === void 0 ? void 0 : poolNames_1[index],
                                    coins: coins,
                                };
                                poolOptions_1.push(option);
                            });
                            input.poolAddress.options = poolOptions_1;
                            return [2 /*return*/, {
                                    params: {},
                                    error: undefined,
                                }];
                        case 'poolAddress':
                            poolAddress_1 = input.poolAddress.value;
                            if (typeof poolAddress_1 !== 'string') {
                                return [2 /*return*/, {
                                        params: {},
                                        error: undefined,
                                    }];
                            }
                            (_f = input.poolAddress.options) === null || _f === void 0 ? void 0 : _f.find(function (pool) {
                                if (pool.value !== poolAddress_1)
                                    return;
                                if (!pool.coins)
                                    return;
                                var coin1 = pool.coins[0];
                                var coin2 = pool.coins[1];
                                if (coin1) {
                                    input.token1.value = coin1.address;
                                }
                                if (coin2) {
                                    input.token2.value = coin2.address;
                                }
                            });
                            return [2 /*return*/, {
                                    params: {},
                                    error: undefined,
                                }];
                    }
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                });
            });
        };
        return {
            get: getPoolAddressList,
            depParamKeys: ['pool_tuple[]', 'poolAddress'],
        };
    },
});
